import axios from 'axios';
import routes from 'app/routes';

export default {
  load: (dispatch) => {
    axios.get(
      routes.api.coaches.invoices.index,
    ).then((resp) => {
      dispatch({ type: 'LOAD', invoices: resp.data.data });
    });
  },
  update: (dispatch, id, values, callback) => {
    axios.patch(
      routes.api.coaches.invoices.update(id),
      values,
    ).then((resp) => {
      dispatch({ type: 'UPDATE', invoice: resp.data.data });
      callback();
    });
  },
  cancel: (id, values, callback) => {
    axios.post(
      routes.api.coaches.invoices.cancel(id),
      values,
    ).then((_resp) => {
      callback();
    });
  },
};
